// extracted by mini-css-extract-plugin
export default {"container":"style_container__ePDMR","title":"style_title__-K8-T"};